/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When do you hyphenate numbers in words?`)
};

const es_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo insiertas guiones en números en palabras?`)
};

const de_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann werden Zahlen in Worten mit Bindestrich geschrieben?`)
};

const nl_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanneer koppel je getallen in woorden?`)
};

const fr_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand faut-il mettre un trait d'union dans les nombres en lettres ?`)
};

const it_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando usi i trattini nei numeri in parole?`)
};

const pt_br2_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você adiciona hífen em números em palavras?`)
};

const pt_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando se devem hifenizar os números por extenso?`)
};

const ja_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語での数字にハイフンを付ける場合はいつですか？`)
};

const zh_nw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么时候需要在数字文字中加连字符？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq4_q", locale)
	if (locale === "en") return en_nw_faq4_q(inputs)
	if (locale === "es") return es_nw_faq4_q(inputs)
	if (locale === "de") return de_nw_faq4_q(inputs)
	if (locale === "nl") return nl_nw_faq4_q(inputs)
	if (locale === "fr") return fr_nw_faq4_q(inputs)
	if (locale === "it") return it_nw_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq4_q(inputs)
	if (locale === "pt") return pt_nw_faq4_q(inputs)
	if (locale === "ja") return ja_nw_faq4_q(inputs)
	return zh_nw_faq4_q(inputs)
};